import React, {useContext, useMemo} from 'react';
import {useSelector} from 'react-redux';

import {mapDateFormat} from 'src/utils/mapDateFormat';

import {FormattedDate} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';


import {
    accountSearchResultLicenseDataSelector,
    accountSearchResultLicenseResultSelector,
} from '../../slices/account-search-result-license.slice';

type Props = {
    accountId: number,
};

export const LicenseEndDateCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultLicenseDataSelector);
    const result = useSelector(accountSearchResultLicenseResultSelector);
    const {locale} = useContext(LocaleContext);

    const licenseEnds = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].licenseEnds;
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !licenseEnds) {
        return null;
    }

    return (
        <span>
            {FormattedDate.format({
                value: licenseEnds,
                format: mapDateFormat(locale.dateFormat, 'NUMERIC'),
            })}
        </span>
    );
};
